import VueWait from 'vue-wait'

export const wait = new VueWait()

export const WaitStates = {
  LOGIN_LOADING: 'login loading',
  REGISTER_LOADING: 'register loading',
  FORGOT_PASSWORD_LOADING: 'forgot password loading',
  RESET_PASSWORD_LOADING: 'reset password loading',
  CREATE_ORGANIZATION_LOADING: 'create organization loading',
  CREATE_BASIC_ORGANIZATION_LOADING: 'create basic organization loading',
  REGISTER_EMAIL_LOADING: 'register email loading'
}
